import { WebinarContentSummary } from '@core/swagger-client';
import { WebinarStatus } from '@core/types';
import { TestWebinarBadge, useTestWebinarDeleteOn, WarningOutlined } from '@core/ui';
import { useTranslation } from 'react-i18next';
import { UpNextWebinarActions, UpNextWebinarData, UpNextWebinarHeader, UpNextWebinarInfo } from '../../molecules';

export const UpNextWebinar = ({ upcomingWebinar }: { upcomingWebinar: WebinarContentSummary }) => {
    const { t } = useTranslation();
    // Hooks run unconditionally; the value is only shown for a test webinar.
    const deleteOn = useTestWebinarDeleteOn(upcomingWebinar.broadcastDateTime);

    return (
        <article
            data-webinar-id={upcomingWebinar.webinarId}
            className={
                'webinar-item ' +
                (upcomingWebinar.visibility && upcomingWebinar.isPublished ? 'after:bg-primary' : '') +
                (!upcomingWebinar.visibility && upcomingWebinar.isPublished ? 'after:bg-secondary' : '') +
                (!upcomingWebinar.isPublished ? 'after:bg-warning' : '') +
                (upcomingWebinar.status === WebinarStatus.Started ? 'after:bg-success' : '')
            }
        >
            {!upcomingWebinar.isPublished && (
                <span>
                    <WarningOutlined />
                    {t('Webinar.Warning.NotPublished')}
                </span>
            )}
            <div className="bg-accent-light z-10">
                <UpNextWebinarHeader title={upcomingWebinar.title} isVisible={upcomingWebinar.visibility} />
                {upcomingWebinar.isTest && (
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                        <TestWebinarBadge />
                        <span className="text-sm">{t('Webinar.Test.DeleteOn', { deleteOn })}</span>
                    </div>
                )}
                <UpNextWebinarInfo
                    broadcastDateTime={upcomingWebinar.broadcastDateTime}
                    nameOfHost={upcomingWebinar.nameOfHost}
                    plannedDuration={upcomingWebinar.plannedDuration}
                    status={upcomingWebinar.status}
                    startedTime={upcomingWebinar.startedOn ?? upcomingWebinar.broadcastDateTime}
                />
            </div>
            <UpNextWebinarData webinar={upcomingWebinar} />
            <UpNextWebinarActions webinar={upcomingWebinar} />
        </article>
    );
};
